// Payment Schemas - Ορισμός δομών δεδομένων και validation για πληρωμές

window.PaymentSchemas = {
  
  /**
   * Schema για δημιουργία νέας πληρωμής
   */
  createPayment: {
    client_id: {
      required: false,
      type: 'number',
      label: 'Πελάτης'
    },
    invoice_id: {
      required: false,
      type: 'number',
      label: 'Τιμολόγιο'
    },
    amount: {
      required: true,
      type: 'number',
      min: 0.01,
      label: 'Ποσό'
    },
    payment_method: {
      required: true,
      type: 'select',
      label: 'Τρόπος Πληρωμής',
      options: [
        { value: 'cash', label: 'Μετρητά' },
        { value: 'bank_transfer', label: 'Τραπεζική Κατάθεση' },
        { value: 'card', label: 'Κάρτα' },
        { value: 'check', label: 'Επιταγή' },
        { value: 'other', label: 'Άλλο' }
      ]
    },
    payment_date: {
      required: true,
      type: 'date',
      label: 'Ημερομηνία Πληρωμής'
    },
    reference_number: {
      required: false,
      type: 'string',
      maxLength: 100,
      label: 'Αριθμός Αναφοράς'
    },
    notes: {
      required: false,
      type: 'text',
      label: 'Σημειώσεις'
    },
    allocations: {
      required: false,
      type: 'array',
      label: 'Κατανομή σε Υπηρεσίες',
      itemSchema: {
        service_id: {
          required: true,
          type: 'number',
          label: 'Υπηρεσία'
        },
        allocated_amount: {
          required: true,
          type: 'number',
          min: 0.01,
          label: 'Ποσό'
        },
        notes: {
          required: false,
          type: 'string',
          label: 'Σημειώσεις'
        }
      }
    }
  },

  /**
   * Schema για ενημέρωση πληρωμής
   */
  updatePayment: {
    client_id: {
      required: false,
      type: 'number',
      label: 'Πελάτης'
    },
    invoice_id: {
      required: false,
      type: 'number',
      label: 'Τιμολόγιο'
    },
    amount: {
      required: false,
      type: 'number',
      min: 0.01,
      label: 'Ποσό'
    },
    payment_method: {
      required: false,
      type: 'select',
      label: 'Τρόπος Πληρωμής',
      options: [
        { value: 'cash', label: 'Μετρητά' },
        { value: 'bank_transfer', label: 'Τραπεζική Κατάθεση' },
        { value: 'card', label: 'Κάρτα' },
        { value: 'check', label: 'Επιταγή' },
        { value: 'other', label: 'Άλλο' }
      ]
    },
    payment_date: {
      required: false,
      type: 'date',
      label: 'Ημερομηνία Πληρωμής'
    },
    reference_number: {
      required: false,
      type: 'string',
      maxLength: 100,
      label: 'Αριθμός Αναφοράς'
    },
    notes: {
      required: false,
      type: 'text',
      label: 'Σημειώσεις'
    }
  },

  /**
   * Schema για κατανομή πληρωμής
   */
  createAllocation: {
    service_id: {
      required: true,
      type: 'number',
      label: 'Υπηρεσία'
    },
    allocated_amount: {
      required: true,
      type: 'number',
      min: 0.01,
      label: 'Ποσό'
    },
    notes: {
      required: false,
      type: 'string',
      label: 'Σημειώσεις'
    }
  },

  /**
   * Αρχικές τιμές για νέα πληρωμή
   */
  defaultValues: {
    client_id: null,
    invoice_id: null,
    amount: '',
    payment_method: 'bank_transfer',
    payment_date: new Date().toISOString().split('T')[0],
    reference_number: '',
    notes: '',
    allocations: []
  },

  /**
   * Αρχικές τιμές για νέα κατανομή
   */
  defaultAllocationValues: {
    service_id: null,
    allocated_amount: '',
    notes: ''
  },

  /**
   * Validation συνάρτηση
   * @param {Object} data - Δεδομένα προς validation
   * @param {string} schemaType - Τύπος schema ('createPayment', 'updatePayment', 'createAllocation')
   * @returns {Object} - Αποτέλεσμα validation
   */
  validate(data, schemaType = 'createPayment') {
    const schema = this[schemaType];
    const errors = {};

    for (const [field, rules] of Object.entries(schema)) {
      const value = data[field];

      // Έλεγχος υποχρεωτικών πεδίων
      if (rules.required && (value === null || value === undefined || value === '')) {
        errors[field] = `Το πεδίο "${rules.label}" είναι υποχρεωτικό`;
        continue;
      }

      // Αν το πεδίο είναι κενό και δεν είναι υποχρεωτικό, συνέχισε
      if (value === null || value === undefined || value === '') {
        continue;
      }

      // Έλεγχος τύπου
      if (rules.type === 'number') {
        const numValue = parseFloat(value);
        if (isNaN(numValue)) {
          errors[field] = `Το πεδίο "${rules.label}" πρέπει να είναι αριθμός`;
        } else {
          if (rules.min !== undefined && numValue < rules.min) {
            errors[field] = `Το πεδίο "${rules.label}" πρέπει να είναι τουλάχιστον ${rules.min}`;
          }
          if (rules.max !== undefined && numValue > rules.max) {
            errors[field] = `Το πεδίο "${rules.label}" δεν μπορεί να ξεπερνά το ${rules.max}`;
          }
        }
      }

      if (rules.type === 'date') {
        if (!value || isNaN(new Date(value).getTime())) {
          errors[field] = `Το πεδίο "${rules.label}" πρέπει να είναι έγκυρη ημερομηνία`;
        }
      }

      if (rules.type === 'email') {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value)) {
          errors[field] = `Το πεδίο "${rules.label}" πρέπει να είναι έγκυρο email`;
        }
      }

      // Έλεγχος μήκους για strings
      if (rules.type === 'string' && typeof value === 'string') {
        if (rules.maxLength && value.length > rules.maxLength) {
          errors[field] = `Το πεδίο "${rules.label}" δεν μπορεί να ξεπερνά τους ${rules.maxLength} χαρακτήρες`;
        }
        if (rules.minLength && value.length < rules.minLength) {
          errors[field] = `Το πεδίο "${rules.label}" πρέπει να έχει τουλάχιστον ${rules.minLength} χαρακτήρες`;
        }
      }

      // Έλεγχος array για allocations
      if (rules.type === 'array' && Array.isArray(value)) {
        if (rules.required && value.length === 0) {
          errors[field] = `Το πεδίο "${rules.label}" είναι υποχρεωτικό`;
        }
        
        // Validate each allocation
        if (rules.itemSchema) {
          value.forEach((item, index) => {
            const itemErrors = this.validate(item, 'createAllocation');
            if (!itemErrors.isValid) {
              errors[`${field}[${index}]`] = itemErrors.errors;
            }
          });
        }
      }
    }

    // Ειδικός έλεγχος για πληρωμές με allocations
    if (schemaType === 'createPayment' && data.allocations && data.allocations.length > 0) {
      const totalAllocated = data.allocations.reduce((sum, alloc) => sum + (parseFloat(alloc.allocated_amount) || 0), 0);
      const paymentAmount = parseFloat(data.amount) || 0;
      
      if (totalAllocated > paymentAmount) {
        errors.allocations = 'Το συνολικό ποσό των κατανομών δεν μπορεί να ξεπερνά το ποσό της πληρωμής';
      }
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  },

  /**
   * Λίστα επιλογών για dropdown fields
   */
  options: {
    paymentMethods: [
      { value: 'cash', label: 'Μετρητά' },
      { value: 'bank_transfer', label: 'Τραπεζική Κατάθεση' },
      { value: 'card', label: 'Κάρτα' },
      { value: 'check', label: 'Επιταγή' },
      { value: 'other', label: 'Άλλο' }
    ]
  },

  /**
   * Utility functions για formatting
   */
  formatters: {
    formatAmount: (amount) => {
      return new Intl.NumberFormat('el-GR', {
        style: 'currency',
        currency: 'EUR'
      }).format(amount || 0);
    },
    
    formatDate: (date) => {
      if (!date) return '';
      return new Date(date).toLocaleDateString('el-GR');
    },
    
    formatPaymentMethod: (method) => {
      const methodMap = {
        cash: 'Μετρητά',
        bank_transfer: 'Τραπεζική Κατάθεση',
        card: 'Κάρτα',
        check: 'Επιταγή',
        other: 'Άλλο'
      };
      return methodMap[method] || method;
    }
  }
};
